import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'crm-actions-row',
  templateUrl: './actions-row.component.html',
  styleUrls: ['./actions-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsRowComponent implements OnChanges {
  /**
   * @deprecated Use `align: 'right'` instead
   */
  @Input() right: boolean;
  @Input() class?: string;
  @Input() align?: 'left' | 'center' | 'right' | 'space-between';

  @HostBinding('class') classes = '';

  ngOnChanges(changes: SimpleChanges) {
    this.setClasses();
  }

  private setClasses() {
    const cssClasses: string[] = [];

    if (this.class) {
      cssClasses.push(this.class);
    }

    if (this.right !== undefined && this.right !== false) {
      cssClasses.push('-right');
    }

    if (['left', 'center', 'right', 'space-between'].includes(this.align)) {
      cssClasses.push(`-${this.align}`);
    }

    this.classes = cssClasses.join(' ');
  }
}
